var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c(
        "b-card",
        { staticClass: "mt-3", attrs: { "no-body": "" } },
        [
          _c(
            "b-tabs",
            { attrs: { pills: "", card: "" } },
            [
              _c(
                "b-tab",
                { attrs: { title: "EMail Server", active: "" } },
                [
                  _c(
                    "b-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            "b-form",
                            {
                              on: {
                                submit: function($event) {
                                  return _vm.saveEMailServerConfig()
                                }
                              }
                            },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "g-email-host",
                                    label: "EMail Server Host",
                                    "label-for": "email_host"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "email_host",
                                      type: "text",
                                      required: "",
                                      placeholder: "Enter email server host"
                                    },
                                    model: {
                                      value: _vm.email.host,
                                      callback: function($$v) {
                                        _vm.$set(_vm.email, "host", $$v)
                                      },
                                      expression: "email.host"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "g-email-port",
                                    label: "EMail Server Port",
                                    "label-for": "email_port"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "email_port",
                                      type: "number",
                                      required: "",
                                      placeholder: "Enter email server port"
                                    },
                                    model: {
                                      value: _vm.email.port,
                                      callback: function($$v) {
                                        _vm.$set(_vm.email, "port", $$v)
                                      },
                                      expression: "email.port"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "g-email-user",
                                    label: "User Name",
                                    "label-for": "email_user"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "email_user",
                                      type: "email",
                                      placeholder: "Enter email address"
                                    },
                                    model: {
                                      value: _vm.email.user,
                                      callback: function($$v) {
                                        _vm.$set(_vm.email, "user", $$v)
                                      },
                                      expression: "email.user"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "g-email-pass",
                                    label: "Password",
                                    "label-for": "email_pass"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "email_pass",
                                      type: "password",
                                      placeholder: "Enter password"
                                    },
                                    model: {
                                      value: _vm.email.pass,
                                      callback: function($$v) {
                                        _vm.$set(_vm.email, "pass", $$v)
                                      },
                                      expression: "email.pass"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                { attrs: { id: "exampleGroup4" } },
                                [
                                  _c(
                                    "b-form-checkbox",
                                    {
                                      attrs: {
                                        id: "checkbox1",
                                        value: true,
                                        "unchecked-value": false
                                      },
                                      model: {
                                        value: _vm.email.tls,
                                        callback: function($$v) {
                                          _vm.$set(_vm.email, "tls", $$v)
                                        },
                                        expression: "email.tls"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Use TLS/SSL\n                "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-alert",
                                {
                                  attrs: {
                                    variant: "success",
                                    dismissible: "",
                                    show: _vm.emailSaveOkay
                                  }
                                },
                                [_vm._v("Saved")]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  attrs: { type: "submit", variant: "primary" }
                                },
                                [
                                  _c("i", { staticClass: "fa fa-save" }),
                                  _vm._v(" Save")
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: "File Server", active: "" } },
                [
                  _c(
                    "b-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            "b-form",
                            {
                              on: {
                                submit: function($event) {
                                  return _vm.saveFileServerConfig()
                                }
                              }
                            },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "g-ft",
                                    label: "File Server Type",
                                    "label-for": "ft"
                                  }
                                },
                                [
                                  _c(
                                    "b-form-select",
                                    {
                                      attrs: {
                                        id: "ft",
                                        required: "",
                                        placeholder: "Enter File server host"
                                      },
                                      model: {
                                        value: _vm.file.serverType,
                                        callback: function($$v) {
                                          _vm.$set(_vm.file, "serverType", $$v)
                                        },
                                        expression: "file.serverType"
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        { domProps: { value: null } },
                                        [_vm._v("Please select an option")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "smb" } },
                                        [_vm._v("Windows Server")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "nfs" } },
                                        [_vm._v("NFS Server")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "file" } },
                                        [_vm._v("Local Folder")]
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "g-domain",
                                    label: "File Server Domain",
                                    "label-for": "file_domain"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "file_domain",
                                      type: "text",
                                      required: "",
                                      placeholder: "Enter File server Domain"
                                    },
                                    model: {
                                      value: _vm.file.domain,
                                      callback: function($$v) {
                                        _vm.$set(_vm.file, "domain", $$v)
                                      },
                                      expression: "file.domain"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "g-host",
                                    label: "File Server Host",
                                    "label-for": "file_host"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "file_host",
                                      type: "text",
                                      required: "",
                                      placeholder: "Enter File server host"
                                    },
                                    model: {
                                      value: _vm.file.host,
                                      callback: function($$v) {
                                        _vm.$set(_vm.file, "host", $$v)
                                      },
                                      expression: "file.host"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "g-port",
                                    label: "File Server Path",
                                    "label-for": "file_path"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "file_path",
                                      type: "text",
                                      required: "",
                                      placeholder: "Enter File server path"
                                    },
                                    model: {
                                      value: _vm.file.path,
                                      callback: function($$v) {
                                        _vm.$set(_vm.file, "path", $$v)
                                      },
                                      expression: "file.path"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "g-file-user",
                                    label: "User Name",
                                    "label-for": "file_user"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "file_user",
                                      type: "text",
                                      placeholder: "Enter user name"
                                    },
                                    model: {
                                      value: _vm.file.user,
                                      callback: function($$v) {
                                        _vm.$set(_vm.file, "user", $$v)
                                      },
                                      expression: "file.user"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "g-file-pass",
                                    label: "Password",
                                    "label-for": "file_pass"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "file_pass",
                                      type: "password",
                                      placeholder: "Enter password"
                                    },
                                    model: {
                                      value: _vm.file.pass,
                                      callback: function($$v) {
                                        _vm.$set(_vm.file, "pass", $$v)
                                      },
                                      expression: "file.pass"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "g-update-system",
                                    label: "Update Server",
                                    "label-for": "update_server"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "update_server",
                                      type: "text",
                                      required: "",
                                      placeholder: "Enter Update System"
                                    },
                                    model: {
                                      value: _vm.file.updateSystem,
                                      callback: function($$v) {
                                        _vm.$set(_vm.file, "updateSystem", $$v)
                                      },
                                      expression: "file.updateSystem"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "g-update-user",
                                    label: "Update System User Name",
                                    "label-for": "update_user"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "update_user",
                                      type: "text",
                                      placeholder:
                                        "Enter Update System user name"
                                    },
                                    model: {
                                      value: _vm.file.updateUser,
                                      callback: function($$v) {
                                        _vm.$set(_vm.file, "updateUser", $$v)
                                      },
                                      expression: "file.updateUser"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "g-update-pass",
                                    label: "Password",
                                    "label-for": "update_pass"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "update_pass",
                                      type: "password",
                                      placeholder:
                                        "Enter Update System password"
                                    },
                                    model: {
                                      value: _vm.file.updatePass,
                                      callback: function($$v) {
                                        _vm.$set(_vm.file, "updatePass", $$v)
                                      },
                                      expression: "file.updatePass"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        id: "g-update-procedure",
                                        label: "Update Procedure",
                                        "label-for": "update_procedure"
                                      }
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "update_procedure",
                                          type: "text",
                                          required: "",
                                          placeholder: "Enter Update Procedure"
                                        },
                                        model: {
                                          value: _vm.file.updateProcedure,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.file,
                                              "updateProcedure",
                                              $$v
                                            )
                                          },
                                          expression: "file.updateProcedure"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-alert",
                                {
                                  attrs: {
                                    variant: "success",
                                    dismissible: "",
                                    show: _vm.fileSaveOkay
                                  }
                                },
                                [_vm._v("Saved")]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-btn-group",
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        type: "submit",
                                        variant: "primary"
                                      }
                                    },
                                    [
                                      _c("i", { staticClass: "fa fa-save" }),
                                      _vm._v(" Save")
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        type: "button",
                                        variant: "info"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.checkFS.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("i", { staticClass: "fa fa-check" }),
                                      _vm._v(" Check\n                ")
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: "SMS Server" } },
                [
                  _c(
                    "b-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            "b-form",
                            {
                              on: {
                                submit: function($event) {
                                  return _vm.saveSMSServerConfig()
                                }
                              }
                            },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "g-sms-host",
                                    label: "SMS Server Host",
                                    "label-for": "sms_host"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "sms_host",
                                      type: "text",
                                      required: "",
                                      placeholder: "Enter email server host"
                                    },
                                    model: {
                                      value: _vm.sms.host,
                                      callback: function($$v) {
                                        _vm.$set(_vm.sms, "host", $$v)
                                      },
                                      expression: "sms.host"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "g-sms-user",
                                    label: "User Name",
                                    "label-for": "sms_user"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "sms_user",
                                      type: "email",
                                      placeholder: "Enter email address"
                                    },
                                    model: {
                                      value: _vm.sms.user,
                                      callback: function($$v) {
                                        _vm.$set(_vm.sms, "user", $$v)
                                      },
                                      expression: "sms.user"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "g-sms-pass",
                                    label: "Password",
                                    "label-for": "sms_pass"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "sms_pass",
                                      type: "password",
                                      placeholder: "Enter password"
                                    },
                                    model: {
                                      value: _vm.sms.pass,
                                      callback: function($$v) {
                                        _vm.$set(_vm.sms, "pass", $$v)
                                      },
                                      expression: "sms.pass"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-alert",
                                {
                                  attrs: {
                                    variant: "success",
                                    dismissible: "",
                                    show: _vm.smsSaveOkay
                                  }
                                },
                                [_vm._v("Saved")]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  attrs: { type: "submit", variant: "primary" }
                                },
                                [
                                  _c("i", { staticClass: "fa fa-save" }),
                                  _vm._v(" Save")
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: "Daily EMail Notifications" } },
                [
                  _c(
                    "b-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form",
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: { label: "POD Pending Notification" }
                                },
                                [
                                  _c(
                                    "b-form-checkbox-group",
                                    {
                                      attrs: {
                                        id: "podPending0",
                                        name: "podPending"
                                      },
                                      model: {
                                        value: _vm.notification.podPending,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.notification,
                                            "podPending",
                                            $$v
                                          )
                                        },
                                        expression: "notification.podPending"
                                      }
                                    },
                                    [
                                      _c(
                                        "b-form-checkbox",
                                        { attrs: { value: "ADMIN" } },
                                        [_vm._v("Administrator")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-checkbox",
                                        { attrs: { value: "REGULAR_USER" } },
                                        [_vm._v("Company User")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-checkbox",
                                        { attrs: { value: "TRANSPORTER" } },
                                        [_vm._v("Transporter")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: { label: "POD Dispute Notification" }
                                },
                                [
                                  _c(
                                    "b-form-checkbox-group",
                                    {
                                      attrs: {
                                        id: "podPending1",
                                        name: "podDispute"
                                      },
                                      model: {
                                        value: _vm.notification.podDispute,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.notification,
                                            "podDispute",
                                            $$v
                                          )
                                        },
                                        expression: "notification.podDispute"
                                      }
                                    },
                                    [
                                      _c(
                                        "b-form-checkbox",
                                        { attrs: { value: "ADMIN" } },
                                        [_vm._v("Administrator")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-checkbox",
                                        { attrs: { value: "REGULAR_USER" } },
                                        [_vm._v("Company User")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-checkbox",
                                        { attrs: { value: "TRANSPORTER" } },
                                        [_vm._v("Transporter")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Undelivered & E-Waybill Expiry"
                                  }
                                },
                                [
                                  _c(
                                    "b-form-checkbox-group",
                                    {
                                      attrs: {
                                        id: "podPending2",
                                        name: "ewbExpiry"
                                      },
                                      model: {
                                        value: _vm.notification.ewbExpiry,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.notification,
                                            "ewbExpiry",
                                            $$v
                                          )
                                        },
                                        expression: "notification.ewbExpiry"
                                      }
                                    },
                                    [
                                      _c(
                                        "b-form-checkbox",
                                        { attrs: { value: "ADMIN" } },
                                        [_vm._v("Administrator")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-checkbox",
                                        { attrs: { value: "REGULAR_USER" } },
                                        [_vm._v("Company User")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-checkbox",
                                        { attrs: { value: "TRANSPORTER" } },
                                        [_vm._v("Transporter")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-alert",
                                {
                                  attrs: {
                                    variant: "success",
                                    dismissible: "",
                                    show: _vm.notificationSaveOkay
                                  }
                                },
                                [_vm._v("Saved")]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  attrs: { type: "button", variant: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.saveEMailNotifications()
                                    }
                                  }
                                },
                                [
                                  _c("i", { staticClass: "fa fa-save" }),
                                  _vm._v(
                                    "\n                Save\n              "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: "EMail Alerts" } },
                [
                  _c(
                    "b-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form",
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: "Dispute Raised" } },
                                [
                                  _c(
                                    "b-form-checkbox-group",
                                    {
                                      attrs: {
                                        id: "disputeRaised",
                                        name: "disputeRaised"
                                      },
                                      model: {
                                        value: _vm.alerts.disputeRaised,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.alerts,
                                            "disputeRaised",
                                            $$v
                                          )
                                        },
                                        expression: "alerts.disputeRaised"
                                      }
                                    },
                                    [
                                      _c(
                                        "b-form-checkbox",
                                        { attrs: { value: "ADMIN" } },
                                        [_vm._v("Administrator")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-checkbox",
                                        { attrs: { value: "REGULAR_USER" } },
                                        [_vm._v("Company User")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-checkbox",
                                        { attrs: { value: "TRANSPORTER" } },
                                        [_vm._v("Transporter")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                { attrs: { label: "Dispute Resolved" } },
                                [
                                  _c(
                                    "b-form-checkbox-group",
                                    {
                                      attrs: {
                                        id: "disputeResolved",
                                        name: "disputeResolved"
                                      },
                                      model: {
                                        value: _vm.alerts.disputeResolved,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.alerts,
                                            "disputeResolved",
                                            $$v
                                          )
                                        },
                                        expression: "alerts.disputeResolved"
                                      }
                                    },
                                    [
                                      _c(
                                        "b-form-checkbox",
                                        { attrs: { value: "ADMIN" } },
                                        [_vm._v("Administrator")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-checkbox",
                                        { attrs: { value: "REGULAR_USER" } },
                                        [_vm._v("Company User")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-checkbox",
                                        { attrs: { value: "TRANSPORTER" } },
                                        [_vm._v("Transporter")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                { attrs: { label: "Dispute Updated" } },
                                [
                                  _c(
                                    "b-form-checkbox-group",
                                    {
                                      attrs: {
                                        id: "disputeComment",
                                        name: "disputeComment"
                                      },
                                      model: {
                                        value: _vm.alerts.disputeComment,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.alerts,
                                            "disputeComment",
                                            $$v
                                          )
                                        },
                                        expression: "alerts.disputeComment"
                                      }
                                    },
                                    [
                                      _c(
                                        "b-form-checkbox",
                                        { attrs: { value: "ADMIN" } },
                                        [_vm._v("Administrator")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-checkbox",
                                        { attrs: { value: "REGULAR_USER" } },
                                        [_vm._v("Company User")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-checkbox",
                                        { attrs: { value: "TRANSPORTER" } },
                                        [_vm._v("Transporter")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-alert",
                                {
                                  attrs: {
                                    variant: "success",
                                    dismissible: "",
                                    show: _vm.alertSaveOkay
                                  }
                                },
                                [_vm._v("Saved")]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  attrs: { type: "button", variant: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.saveEmailAlerts()
                                    }
                                  }
                                },
                                [
                                  _c("i", { staticClass: "fa fa-save" }),
                                  _vm._v(" Save\n              ")
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: "Misc Configs" } },
                [
                  _c(
                    "b-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form",
                            [
                              _c(
                                "table",
                                { staticClass: "table table-borderless" },
                                [
                                  _c("thead", { staticClass: "thead-dark" }, [
                                    _c("tr", [
                                      _c("th", [_vm._v("Key")]),
                                      _vm._v(" "),
                                      _c("th", [_vm._v("Value")])
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "tbody",
                                    _vm._l(_vm.kvs, function(kv) {
                                      return _c("tr", { key: kv.theKey }, [
                                        _c("td", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: kv.theKey,
                                                expression: "kv.theKey"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            attrs: { type: "text" },
                                            domProps: { value: kv.theKey },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  kv,
                                                  "theKey",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          })
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _c("textarea", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: kv.theValue,
                                                expression: "kv.theValue"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            domProps: { value: kv.theValue },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  kv,
                                                  "theValue",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          })
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _c(
                                            "div",
                                            { staticClass: "btn-group" },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-success",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.saveKV(kv)
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-save"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "button",
                                                {
                                                  staticClass: "btn btn-danger",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.delKV(kv)
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-times"
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                        ])
                                      ])
                                    }),
                                    0
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  attrs: { type: "button", variant: "info" },
                                  on: {
                                    click: function($event) {
                                      return _vm.addKV()
                                    }
                                  }
                                },
                                [
                                  _c("i", { staticClass: "fa fa-plus" }),
                                  _vm._v(" Add")
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: "Actions" } },
                [
                  _c(
                    "b-row",
                    {
                      staticClass: "mt-3 text-center",
                      attrs: { "align-h": "center", "align-v": "center" }
                    },
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                variant: "primary",
                                disabled: _vm.importRunning
                              },
                              on: {
                                click: function($event) {
                                  return _vm.runTranslogImport()
                                }
                              }
                            },
                            [
                              !_vm.importRunning
                                ? _c("span", [_vm._v("Run Translog Import")])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.importRunning
                                ? _c("span", [
                                    _vm._v("Translog Import in progress")
                                  ])
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                variant: "warning",
                                disabled: _vm.updateRunning
                              },
                              on: {
                                click: function($event) {
                                  return _vm.runTranslogUpdate()
                                }
                              }
                            },
                            [
                              !_vm.updateRunning
                                ? _c("span", [_vm._v("Run Translog Update")])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.updateRunning
                                ? _c("span", [
                                    _vm._v("Translog Update in progress")
                                  ])
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "danger" },
                              on: {
                                click: function($event) {
                                  return _vm.clearCache()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              Clear Cache\n            "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                variant: "info",
                                disabled: _vm.podRunning
                              },
                              on: {
                                click: function($event) {
                                  return _vm.triggerPOD()
                                }
                              }
                            },
                            [
                              !_vm.podRunning
                                ? _c("span", [_vm._v("Download POD")])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.podRunning
                                ? _c("span", [
                                    _vm._v("POD Download in progress")
                                  ])
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "secondary" },
                              on: {
                                click: function($event) {
                                  return _vm.updateTRLocation()
                                }
                              }
                            },
                            [
                              _c("span", [
                                _vm._v("Update Transporter Locations")
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                variant: "warning",
                                disabled: _vm.ewbRunning
                              },
                              on: {
                                click: function($event) {
                                  return _vm.updatePartB()
                                }
                              }
                            },
                            [_c("span", [_vm._v("Update Part-B")])]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f9c3f61", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f9c3f61","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/ConfigPage.vue
// module id = null
// module chunks = 